// Default theme settings configurations

export const ThemeSettingsPublicoConfig = {
    colorTheme: 'dark', // light, semi-light, semi-dark, dark
    layout: {
      style: 'vertical', // style: 'vertical', horizontal,
      pattern: 'fixed' // fixed, boxed, static
    },
    menuColor: 'menu-dark', // Vertical: [menu-dark, menu-light] , Horizontal: [navbar-dark, navbar-light]
    navigation: 'menu-collapsible', // menu-collapsible, menu-accordation
    menu: 'collapse', // collapse, expand
    header: 'fix', // fix, static
    footer: 'fix', // fix, static
    customizer: 'off', // on,off
    buybutton: 'off', // on, off
    headerIcons: {
      maximize: 'off', // on, off
      search: 'off', // on, off
      internationalization: 'off', // on, off
      notification: 'off', // on, off
      email: 'off' // on, off
    },
    brand: {
      brand_name: 'SATE TI UTP',
      logo: {
        type: 'url', // internal, url
        value: 'https://res.cloudinary.com/drtcnv1st/image/upload/v1682361692/Custom/logo-utp_suewjt.png' 
        // recommended location for custom images
      },
    },
    defaultTitleSuffix: 'Publico'
  };
  